import {
  collection,
  getDocs,
  doc,
  updateDoc,
  serverTimestamp,
  onSnapshot,
} from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Admin (and system) messages delivered to coaches under users/{coachId}/portalMessages.
 */
export async function getPortalMessagesForCoach(userId) {
  if (!userId) return [];
  try {
    const snap = await getDocs(collection(db, 'users', userId, 'portalMessages'));
    const rows = snap.docs.map((d) => {
      const data = d.data();
      const ts = data.timestamp?.toDate
        ? data.timestamp.toDate()
        : data.timestamp
          ? new Date(data.timestamp)
          : new Date(0);
      return {
        id: `portal:${d.id}`,
        portalDocId: d.id,
        adminPostId: data.adminPostId || d.id,
        sender: data.authorName || 'YAU Administration',
        subject: data.title || 'Message',
        message: data.description || '',
        timestamp: ts,
        priority: data.priority || 'normal',
        type: 'admin',
        read: data.read === true,
        imageUrl: data.imageUrl || null,
        source: data.source || 'admin_broadcast',
      };
    });
    rows.sort((a, b) => b.timestamp - a.timestamp);
    return rows;
  } catch (e) {
    console.warn('getPortalMessagesForCoach:', e);
    return [];
  }
}

export async function markCoachPortalMessageAsRead(userId, portalDocId) {
  if (!userId || !portalDocId) return;
  const ref = doc(db, 'users', userId, 'portalMessages', portalDocId);
  await updateDoc(ref, { read: true, readAt: serverTimestamp() });
}

/**
 * Live unread count for users/{userId}/portalMessages (admin + system inbox).
 * @returns {() => void} unsubscribe
 */
export function subscribeCoachPortalUnreadCount(userId, callback) {
  if (!userId) {
    callback(0);
    return () => {};
  }
  const col = collection(db, 'users', userId, 'portalMessages');
  return onSnapshot(
    col,
    (snap) => {
      const unread = snap.docs.filter((d) => d.data().read !== true).length;
      callback(unread);
    },
    (err) => {
      console.warn('subscribeCoachPortalUnreadCount:', err);
      callback(0);
    }
  );
}
